'use client'
import type React from 'react'

import { styled } from '@mui/material/styles'
import { FlexColumn } from 'src/components/Atoms/FlexBox'

interface PageProps {
  children: React.ReactNode
}
const Page: React.FC<PageProps> = styled(FlexColumn)<PageProps>(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',
  backgroundColor: theme.colors.surface.secondary,
}))

export default Page
export type { PageProps }
